import * as React from "react";
const SvgFiRrIgloo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-igloo_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12v7c0 2.757 2.243 5 5 5h2c1.103 0 2-.897 2-2v-5c0-1.654 1.346-3 3-3s3 1.346 3 3v5c0 1.103.897 2 2 2h2c2.757 0 5-2.243 5-5v-7c0-6.617-5.383-12-12-12m10 12v3h-4V9h3.54c.299.947.46 1.955.46 3m-1.342-5H13V2.05A10.02 10.02 0 0 1 20.658 7M11 2.05V7H3.342A10.01 10.01 0 0 1 11 2.05M2 15v-3c0-1.045.161-2.053.46-3H6v6zm5 7H5c-1.654 0-3-1.346-3-3v-2h5zm5-10a5 5 0 0 0-4 2.003V9h8v5.003A5 5 0 0 0 12 12m7 10h-2v-5h5v2c0 1.654-1.346 3-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-igloo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrIgloo;
